/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = [''];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci9qZW5raW5zX2hvbWUvd29ya3NwYWNlL0NMQUlNU19QSVBFTElORS9DTE1UTEtfVUlfQVBQX1BJUEVMSU5FL3NyYy9hcHAvY2xtdGxrL25ldy1tZXNzYWdlL21lc3NhZ2UtZm9ybS9tZXNzYWdlLWVkaXRvci9tZXNzYWdlLWVkaXRvci5jb21wb25lbnQuc2Nzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy92YXIvamVua2luc19ob21lL3dvcmtzcGFjZS9DTEFJTVNfUElQRUxJTkUvQ0xNVExLX1VJX0FQUF9QSVBFTElORS9zcmMvYXBwL2NsbXRsay9uZXctbWVzc2FnZS9tZXNzYWdlLWZvcm0vbWVzc2FnZS1lZGl0b3IvbWVzc2FnZS1lZGl0b3IuY29tcG9uZW50LnNjc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/CLAIMS_PIPELINE/CLMTLK_UI_APP_PIPELINE/src/$$_gendir/app/clmtlk/new-message/message-form/message-editor/message-editor.component.scss.shim.ngstyle.ts